/**
 * Style of inputs component cat. consists of
 * - buttonStyle,
 * - buttonGroupStyle,
 * - checkboxStyle,
 * - and etc.
 */
export const formStyles = (theme) => ({
  formStyle: {
    margin: theme.spacing(1, 0),

    '& > *': {
      margin: theme.spacing(1, 0, 2, 0),
    },
  },
  fieldMargin: {
    margin: theme.spacing(1, 0, 2, 0),
  }
});
/**
 * buttonStyles
 * @param {*} theme
 */
export const buttonStyles = (theme) => {
  const buttonCoreStyle = {
    minWidth: '6.3vw',
    fontSize: '0.8rem',
    height: '30px',
  };
  return {
    btnLayoutStyle: {
      ...buttonCoreStyle,
      margin: theme.spacing(1),
    },
    btnLayoutLeftStyle: {
      ...buttonCoreStyle,
      margin: theme.spacing(0.3, 1.2, 0.3, 0),
    },
    btnLayoutRightStyle: {
      ...buttonCoreStyle,
      margin: theme.spacing(0.3, 0, 0.3, 1.2),
    },
  };
};
